



  <div class="mid-div" style="padding: 20px">
    <h5 class="font-weight-bold text-center">System selection</h5>
<!--    <div class="col-12 row ">-->
<!--      <div class="col-4 travel"></div>-->
<!--      <div class="col-4 resort"></div>-->
<!--      <div class="col-4 enterprice"></div>-->
<!--    </div>-->

    <div class="row">
      <div class="col-xl-4 col-lg-4">
        <div class="card mb-5">
          <img alt="..." style="height: 22.5rem" class="card-img-top" src="assets/images/4354884.svg"/>
          <div class="card-body">
            <h5 class="card-title font-weight-bold font-size-lg">3R International</h5>
            <p class="card-text">Some quick example text to build on the card title and make up the bulk of the
              card's content.</p>
            <button class="btn btn-primary" (click)="inter()">Access</button>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4">
        <div class="card mb-5">
          <img alt="..." class="card-img-top" style="height: 22.5rem" src="assets/images/g1c0.svg"/>
          <div class="card-body">
            <h5 class="card-title font-weight-bold font-size-lg">3R Resort</h5>
            <p class="card-text">Some quick example text to build on the card title and make up the bulk of the
              card's content.</p>
            <button class="btn btn-primary" (click)="resort()">Access</button>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4">
        <div class="card mb-5">
          <img alt="..." class="card-img-top" style="height: 22.5rem" src="assets/images/4775543.svg"/>
          <div class="card-body">
            <h5 class="card-title font-weight-bold font-size-lg">3R Travels</h5>
            <p class="card-text">Some quick example text to build on the card title and make up the bulk of the
              card's content.</p>
            <button class="btn btn-primary" (click)="travels()">Access</button>
          </div>
        </div>
      </div>
    </div>

  </div>
